/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import client from './apiClient';


const getLookUpData = (key, clientIdOrParams) => {
  const isLegacy = !clientIdOrParams || typeof clientIdOrParams !== 'object';

  const clientId = isLegacy ? clientIdOrParams : clientIdOrParams?.clientId;
  const page = isLegacy ? null : clientIdOrParams?.page;
  const pageSize = isLegacy ? null : clientIdOrParams?.pageSize;
  const search = isLegacy ? null : clientIdOrParams?.search;
  const audienceFilter = isLegacy ? null : clientIdOrParams?.audienceFilter;
  const isFree = isLegacy ? null : clientIdOrParams?.isFree;

  let params = clientId ? `&clientId=${clientId}` : '';
  if (page) params += `&page=${page}`;
  if (pageSize) params += `&pageSize=${pageSize}`;
  if (search) params += `&search=${encodeURIComponent(search)}`;
  if (audienceFilter) params += `&audienceFilter=${audienceFilter.join(',')}`;
  if (isFree !== null && isFree !== undefined) params += `&isFree=${isFree}`;

  return client.get(`/lookup?key=${key}${params}`);
};

const getSubcategoryLookUp = (key, code) => client.get(`/lookup?key=${key}&&code=${code}`);

const getLookUpStateData = (key, id, code) => client.get(`/lookup?key=${key}&Id=${id}&code=${code}`);

const getAuthors = () => client.get(`/user/getAuthors`);
const getLanguageCode = () => client.get(`/user/getLanguageCode`);
const getLoginPageImage = () => client.get(`/user/getLoginImage`);


const getSuperAdminChapters = () => client.get('/course/chapters/chapterlistadmin');
const getClientList = (page = 0, size = 10, search = '', status = 'all', mode = 'all') => client.get(`/client?page=${page}&size=${size}&search=${search}&status=${status}&mode=${mode}`);
const getContentWriterList = (page = 1, limit = 10, search = '') =>
  client.get(`/individual/user/contentwriter?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`); const postContentWriterList = (data) => client.post(`/individual/user/postcontentwriter`, data);
const putContentWriterList = (data, id) => client.put(`/individual/user/updateContentcreater?id=${id}`, data)
const deleteContentWriterList = (id, status) => client.delete(`/individual/user/deleteContentWriter?Id=${id}&status=${status}`)
const getIndividualList = (page, pageCount, sortOrder, sort, search, status,fromDate,toDate,userstatus) => client.get(`/individual/user?page=${page}&pageCount=${pageCount}&sortOrder=${sortOrder}&sort=${sort}&search=${search}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&userstatus=${userstatus}`);
const getIndividualListByPlan = (page, pageCount, sortOrder, sort, search, status, plan,fromDate,toDate) => client.get(`/individual/user/plandetails?page=${page}&pageCount=${pageCount}&sortOrder=${sortOrder}&sort=${sort}&search=${search}&status=${status}&plan=${plan}&fromDate=${fromDate}&toDate=${toDate}`);
const getIndividualListDownload= (sortOrder, sort, search, status, plan,fromDate,toDate,userstatus,comingfrom) => client.get(`/individual/user/download?sortOrder=${sortOrder}&sort=${sort}&search=${search}&status=${status}&plan=${plan}&fromDate=${fromDate}&toDate=${toDate}&userstatus=${userstatus}&comingfrom=${comingfrom}`);

const getReferenceFileDetails = (courseSubModuleId, submodulename, isfree) => client.get(`/course/submodule/getRefFile?courseSubModuleId=${courseSubModuleId}&submodulename=${submodulename}&Is_free=${isfree}`)
const getCourseLists = (page, search, pageCount, source) => {
  const src = source ? `&source=${source}` : '';
  return client.get(`/course?&page=${page}&search=${search}&pageCount=${pageCount}${src}`);
};




const suspendUser = (userId, action, reason) => client.post(`/individual/user/suspendUser`, { userId, action, reason });

const getAllCourseList = () =>
  client.get(`/course/screen/allCourseList`);
 
const deleteCourseVideo = (id) => client.delete(`/course/video?courseId=${id}`);

const getCourseDetailsById = (courseId, source) => client.get(`/course?courseId=${courseId}&source=${source}`);

const getCourseDetailsByIdOne = (clientId) => client.get(`/client?clientId=${clientId}`);

const getCourseContent = (id, source) => client.get(`/course?courseId=${id}&source=${source}`);

const getCourseModule = (courseId, source) => client.get(`/course/module/submodule?courseId=${courseId}&source=${source}`);

const deleteCourseModule = (courseId, moduleId) =>
  client.delete(`/course/module?courseId=${courseId}&&courseModuleId=${moduleId}`);

const getCourseModuleTopics = (subModuleId, sourse) =>
  client.get(`/course/subModuleTopics/screen?courseSubModuleId=${subModuleId}&sourse=${sourse}`);

const editCourseDetailsByIdOne = (clientId, data) => client.put(`/client?clientId=${clientId}`, data);
 
const editCourseModuleName = (courseId, moduleId, data) =>
  client.put(`/course/module?courseId=${courseId}&&courseModuleId=${moduleId}`, data);

const editCourseSubModuleName = (moduleId, submoduleId, data, courseId) =>
  client.put(`/course/subModule?courseModuleId=${moduleId}&&courseSubModuleId=${submoduleId}&&courseId=${courseId}`, data);

const createCourse = (data) => client.post(`/course`, data);
 
const editCourseDetails = (courseId, data) => client.put(`/course?courseId=${courseId}`, data);
 
const createCourseModule = (courseId, data) => client.post(`/course/module?courseId=${courseId}`, JSON.stringify(data));

const createCourseSubModule = (moduleId, data, courseId) => client.post(`/course/subModule?courseModuleId=${moduleId}&&courseId=${courseId}`, data);

const createCourseTopic = (subModuleId, data, courseId) =>
  client.post(`/course/subModuleTopics?courseSubModuleId=${subModuleId}&&courseId=${courseId}`, JSON.stringify(data));

const deleteSubModules = (moduleId, subModuleId) =>
  client.delete(`/course/subModule?courseModuleId=${moduleId}&&courseSubModuleId=${subModuleId}`);

const editSubModuleTopicName = (moduleId, topicId, data, courseId) =>
  client.put(
    `/course/subModuleTopics?courseSubModuleId=${moduleId}&&courseSubModuleTopicId=${topicId}&&courseId=${courseId}`,
    JSON.stringify(data)
  );
 
const deleteSubModuleTopic = (moduleId, topicId) =>
  client.delete(`/course/subModuleTopics?courseSubModuleId=${moduleId}&&courseSubModuleTopicId=${topicId}`);

const createIntroScreenDetails = (topicId, data, courseId) => client.post(`/course/screen/intro?topicId=${topicId}&&courseId=${courseId}`, data);

const updateIntroScreenDetails = (topicId, screenId, data, courseId) =>
  client.put(`/course/screen/intro?topicId=${topicId}&&screenId=${screenId}&&courseId=${courseId}`, data);

const updateActionScreenDetails = (topicId, screenId, data, courseId) =>
  client.put(`/course/screen/action?topicId=${topicId}&&screenId=${screenId}&courseId=${courseId}`, data);
 
const updateVideoScreenDetails = (topicId, screenId, data, courseId) =>
  client.put(`/course/screen/video?topicId=${topicId}&&screenId=${screenId}&courseId=${courseId}`, data);

const updateSuccessScreenDetails = (topicId, screenId, data, courseId) =>
  client.put(`/course/screen/success?topicId=${topicId}&&screenId=${screenId}&&courseId=${courseId}`, data);

const createActionScreenDetails = (topicId, data, courseId) =>
  client.post(`/course/screen/action?topicId=${topicId}&courseId=${courseId}`, data);
 
const createVideoScreenDetails = (topicId, data, courseId) =>
  client.post(`/course/screen/video?topicId=${topicId}&courseId=${courseId}`, data);

const createSuccessScreenDetails = (topicId, data, courseId) => client.post(`/course/screen/success?topicId=${topicId}&&courseId=${courseId}`, data);

const getIntroScreenDetailsById = (topicId, screenId, sourse) =>
  client.get(`/course/screen/intro?topicId=${topicId}&&screenId=${screenId}&sourse=${sourse}`);

const getActionScreenDetailsById = (topicId, screenId, actionType) =>
  client.get(`/course/screen/action?topicId=${topicId}&&screenId=${screenId}&&actionType=${actionType}`);
 
const getVideoScreenDetailsById = (topicId, screenId) =>
  client.get(`/course/screen/video?topicId=${topicId}&&screenId=${screenId}`);
 
const getSuccessScreenDetailsById = (topicId, screenId) =>
  client.get(`/course/screen/success?topicId=${topicId}&&screenId=${screenId}`);
 
const deleteScreenById = (topicId, screenId) =>
  client.delete(`/course/screen/?topicId=${topicId}&&screenId=${screenId}`);
 
const postClientDetails = (data) => client.post(`/client`, data);
 
const editClientDetailsByID = (clientId, data) => client.put(`/client?clientId=${clientId}`, data);
 
const getClientDetalsById = (clientId) => client.get(`/client?clientId=${clientId}`);
 
const getDashBoardValues = () => client.get(`/dashboard`);
 
const getDashBoardChart = (fromDate, toDate) =>
  client.get(`/dashboard/individual/userDetails?fromDate=${fromDate}&toDate=${toDate}`);

const getSATDashBoard = (searchedDetails, page, rowsPerPage, sortOption) => client.get(`/dashboard/SATData?search=${searchedDetails}&page=${page}&rowsPerPage=${rowsPerPage}&sortOption=${sortOption}`);

const getLookUpDetails = (key) => client.get(`/lookup?key=${key}`);

const deleteClientDetailsByID = (clientId, slug = '') => client.delete(`/client?clientId=${clientId}${slug ? `&slug=${encodeURIComponent(slug)}` : ''}`);
const getTenantStorage = (clientId) => client.get(`/client/tenant-storage?clientId=${clientId}`);

const postCreateAdmin = (clientId, data) => client.post(`/client/user?clientId=${clientId}`, data);
const postCreateAdminUser = (clientId, data) => client.post(`/client-admin/users?clientId=${clientId}`, data);


const updateUser = (clientId, userId, payload) =>
  client.put(`/client/userUpdate?clientId=${clientId}&userId=${userId}`, payload);

const getClientInfo = (clientId) => client.get(`/client?clientId=${clientId}`);

const getusers = (clientId, page, rowsPerPage, role = '') => client.get(`/client/users?clientId=${clientId}&page=${page}&size=${rowsPerPage}&search=&role=${role}`);
const getTenentUsers = (clientId, page, rowsPerPage, schema) => client.get(`/client-admin/admin-user?clientId=${clientId}&page=${page}&size=${rowsPerPage}&search=&schema=${schema}`);

const getlearners = (clientId, page, rowsPerPage, schema, role = '') => {
  const params = new URLSearchParams({ clientId, page, size: rowsPerPage, search: '', role });
  if (schema) params.append('schema', schema);
  return client.get(`/client-admin/users?${params.toString()}`);
};
const deleteUserDetails = (clientId, userId) => client.delete(`/client/user?clientId=${clientId}&&userId=${userId}`);
const handleClientStatus = (clientId, data) =>
  client.patch(`/client/clientStatus?clientId=${clientId}`, JSON.stringify(data));
const handleUserStatus = (clientId, userId, data) =>
  client.patch(`/client/userStatus?clientId=${clientId}&&userId=${userId}`, JSON.stringify(data));
const profileUpdate = (data) => client.put('/authenticate/profile', data);
const getSubscriptionData = (clientId, schemaName) => client.get(`/subscription/details?clientId=${clientId}&schemaName=${schemaName}`);
const getUserSubscriptionData = (clientId) => client.get(`/subscription/userdetails?clientId=${clientId}`);
const getLLMInteractionLog = () => client.get(`/subscription/llmInteractionLog`);
const getLLMInteractionLogByUserId = (userId) => client.get(`/subscription/llmInteractionLogByUserId?userId=${userId}`);
const editLLMInteractionLogReviewStatus = (userId, status) => client.put(`/subscription/llmInteractionLogEditReviewStatus?userId=${userId}&status=${status}`);
const deleteLLMInteractionLog = (userId) => client.delete(`/subscription/llmInteractionLogEditReviewStatus?userId=${userId}`);
const getUserAssessmentSubscriptionData = (clientId) => client.get(`/subscription/userassessmentdetails?clientId=${clientId}`);
const getUserNeetSubscriptionData = (clientId) => client.get(`/subscription/userneetdetails?clientId=${clientId}`);

const getDashboardRevenue = (days, page, size) => client.get(`/dashboard/dashboardrevenue?days=${days}&page=${page}&size=${size}`);

const postSubsrciptionplan = (clientId, data) =>
  client.post(`/subscription/client?clientId=${clientId}`, JSON.stringify(data));
 
const editSubsrciptionplan = (id, data) => client.put(`/subscription/client?id=${id}`, JSON.stringify(data));
 
const deleteSubsrciptionplanByID = (id) => client.delete(`/subscription/client?id=${id}`);

const getB2BTemplatePlans = () => client.get('/subscription/b2b-template-plan');
const assignB2BTemplateToClient = (data) => client.post('/subscription/assign-b2b-template', JSON.stringify(data));

const getSubscriptionCoursePlansByID = (id) => client.get(`/subscription/client?id=${id}`);
 
const handleSubscriptionStatus = (subscriptionCoursePlanId, data) =>
  client.patch(`/subscription/coursePlan?subscriptionCoursePlanId=${subscriptionCoursePlanId}`, JSON.stringify(data));
 
const deleteActionScreenKeys = (id) => client.delete(`/course/screen/action/key?keyId=${id}`);
 
const createActionScreenKeys = (topicId, screenId, data) =>
  client.post(`/course/screen/action/key?topicId=${topicId}&&screenId=${screenId}`, data);
 
const createActionScreenKeysForCaseStudy = (screenId, data) =>
  client.post(`/course/screen/action/key?screenId=${screenId}&&topicId`, data);
 
const deleteCourseById = (id) => client.delete(`/course?courseId=${id}`);
 
const updateModulePositions = (courseId, data) =>
  client.put(`/course/module/positionIndex?courseId=${courseId}`, JSON.stringify(data));
 
const updateTopicPositions = (id, data) =>
  client.put(`/course/subModuleTopics/positionIndex?courseSubModuleId=${id}`, JSON.stringify(data));
 
const updateCourseStatus = (courseId, data) =>
  client.patch(`/course/status?courseId=${courseId}`, JSON.stringify(data));
 
const getCourseStatus = (key) => client.get(`/lookup?key=${key}`);
 
const updateSubModulePositions = (moduleId, data) =>
  client.put(`/course/subModule/positionIndex?courseModuleId=${moduleId}`, JSON.stringify(data));

const updateSubModuleParent = (from, to, submoduleId) =>
  client.put(`/course/subModule/updateSubModuleParent?from=${from}&&to=${to}&&submoduleId=${submoduleId}`)

const updateScreenPositions = (topicId, data) =>
  client.put(`/course/screen/positionIndex?topicId=${topicId}`, JSON.stringify(data));
 
const courseTrial = (data) => client.post(`/course/trial`, data);
 
const getAdminUserList = (courseId, clientId) => client.get(`/lookup/users?courseId=${courseId}&clientId=${clientId}`);
 
const enrollUserToCourse = (clientId, courseId, data) =>
  client.post(`/user/enroll?clientId=${clientId}&courseId=${courseId}`, JSON.stringify(data));
 
const enrollNewUser = (clientId, courseId, data) =>
  client.post(`/user/course/enroll?clientId=${clientId}&courseId=${courseId}`, JSON.stringify(data));
const handleDeleteModuleVideo = (id) => client.delete(`/course/module/video?courseModuleId=${id}`);

const getChatResult = (data) =>
  client.post(`/user/getChatResponse`, JSON.stringify(data));
 
const handleDeleteSubmoduleVideo = (id) => client.delete(`/course/subModule/video?subModuleId=${id}`);
 
const handleDeleteScreenAudio = (id) => client.delete(`/course/screen/audio?screenId=${id}`);
const getModuleDataValidation = (moduleId, type) => client.patch(`/course/mstatus?moduleId=${moduleId}&&type=${type}`);

const getEnrolledUser = (courseId, clientId, clientPlanId) =>
  client.get(`/user/enroll?courseId=${courseId}&clientId=${clientId}&clientPlanId=${clientPlanId}`);
 
const deleteEnrolledUser = (planId, courseId) => client.delete(`/user/enroll?planId=${planId}&userId=${courseId}`);
 
const postCloningCourses = (courseId, ownerId, authors, data) =>
  client.post(`/course/clone?courseId=${courseId}&authors=${authors}&userId=${ownerId}`, JSON.stringify(data));

const importModules = (courseId, fromCourseId, ownerId, moduleData) =>
  client.post(`/course/import?tocourseId=${courseId}&fromcourseId=${fromCourseId}&authuserid=${ownerId}`, JSON.stringify(moduleData));

const createReference = (moduleId, subModuleId, data) =>
  client.post(`/course/submodule/addRefFile?courseModuleId=${moduleId}&&subModuleId=${subModuleId}`, data);
const editCourseSubModuleRef = (moduleId, subModuleId, data) =>
  client.put(`/course/subModule/editRef?courseModuleId=${moduleId}&&subModuleId=${subModuleId}`, data);
const deletreferenceDetails = (subModuleId, referenceId) =>
  client.delete(`course/subModule/deleteRef?subModuleId=${subModuleId}&referenceid=${referenceId}`);

const updateisCompleteResult = (data) =>
  client.post(`user/videoResult`, data);

const createIntroTemplate = (templatename, data) =>
  client.post(`/course/screen/addTemplate?templatename=${templatename}`, data);
const getIntroTemplate = (sourse) => client.get(`/course/screen/getIntroTemplate?sourse=${sourse}`);

const putIntroTemplate = (templateId, data) =>
  client.put(`/course/screen/editTemplate?templateId=${templateId}`, data);

const deleteTemplate = (templateId) =>
  client.delete(`/course/screen/deleteTemplate?templateId=${templateId}`);
const createQuestionsOld = (data) =>
  client.post(`/course/createQuestionsOld`, data);
const createQuestions = (data) =>
  client.post(`/course/createQuestions`, data);



const getQuestionData = (values) => client.get('/course/getquestions', { values })
 
const getQuestionDataMCQ = (values) => client.get('/course/getquestionsMcq', { values })

// const getQuestionDataMCQNew = (searchQuery) => client.get(`/course/getquestionsMcq?values[]=${searchQuery}`)

const getQuestionDataMCQNew = (searchQuery, page = 1, limit = 10) =>
  client.get(`/course/getquestionsMcq?values[]=${searchQuery}&page=${page}&limit=${limit}`);

const createCourseAssessMent = (subModuleId, from, data) =>
  client.post(`/course/postassessment?courseSubModuleId=${subModuleId}&from=${from}`, JSON.stringify(data));

const getDetailsById = (subModuleId, from) => client.get(`/course/getquestionsbasedoncourseId?courseSubModuleId=${subModuleId}&from=${from}`);

const UpdateCourseAssessMentBasedonId = (subModuleId, from, data) => client.put(`/course/updateassessment?courseSubModuleId=${subModuleId}&from=${from}`, data);

const genericAssessMent = (data) => client.post(`/course/postgenericassessment`, data);
const CognitiveSkillGA = (data) => client.post(`/course/CognitiveSkillGA`, data);
const getCognitiveSkillGA = (search, page, limit) => client.get(`/course/getCognitiveSkillGA?search=${search}&page=${page}&limit=${limit}`);
const CognitiveSkillGAUpdate = (id, data) => client.put(`/course/updateCognitiveSkillGA?Id=${id}`, data);
const getSATAssessmentAdmin = (search, page, limit) => client.get(`/course/getSATAssessmentAdmin?search=${search}&page=${page}&limit=${limit}`);
const getNEETAssessmentAdmin = (search, page, limit) => client.get(`/course/getNEETAssessmentAdmin?search=${search}&page=${page}&limit=${limit}`);
const getNEETSubjectList = () => client.get(`/course/getNEETSubjectList`);
const getNEETChaptersList = (id) => client.get(`/course/getNEETChaptersList?id=${id}`);


const getGenericAssessment = (search, category, page, rowsPerPage) => client.get(`/course/getgenericassessments?search=${search}&category=${category}&page=${page}&size=${rowsPerPage}`);

const updategenericAssessMent = (data, editid) => client.put(`/course/updategenericassessment?id=${editid}`, data)
const deleteGenericAssessment = (assessmentId) => client.delete(`/course/deletegeneralassessment?Id=${assessmentId}`);
const getBasicDetails = (language) => client.get(`/individual/user/getDropdownValue?language=${language}`)
const getBannerDetails = () => client.get('/individual/user/getBannerDetails')
const getLearnerViewing = (language) => client.get(`/individual/user/getLearnerViewingDetails?language=${language}`)
const UpdateGeneralAssessmentStatus = (id, status, data) => client.put(`/course/updateassessmenttoggle?id=${id}&status=${status}`, JSON.stringify(data));
const getAllQuestion = (page, pageCount, search, questionType, level, created, createdDate, modifiedDate, source) => {
  const src = source ? `&source=${source}` : '';
  return client.get(`/course/getAllQuestions?size=${page}&pageCount=${pageCount}&search=${search}&question_type=${questionType}&level=${level}&created_by=${created}&created_date=${createdDate || ''}&modified_date=${modifiedDate || ''}${src}`);
}; const getAllNEETQuestion = (page, pageCount, search, type) => client.get(`/course/getAllNEETQuestions?size=${page}&pageCount=${pageCount}&search=${search}&type=${type}`);
const deleteQuestion = (questionId) => client.put(`/course/deleteQuestionByID?questionId=${questionId}`);
const Updateusercreation = (id, data) => client.put(`/individual/user/updatedetails?Id=${id}`, data);
const UpdateusercreationClientAdmin = (id, data) => client.put(`/individual/user/updateUserDetailsClientAdmin?Id=${id}`, data);
/* const getCustomerPortal = (currentUrl) => {
  return client.get('/individual/user/customerPortal', {
    params: { return_url: currentUrl }
  });
}; */
const getCustomerPortal = (currentUrl) => client.get(`/individual/user/customerPortal?return_url=${currentUrl}`);
const updateNotificationPreferences = (data) => client.put('/individual/user/updateNotificationPreferences', data);
const getNotificationPreferences = () => client.get('/individual/user/getNotificationPreferences');

// const getUserProfileDetails = (id) => client.get(`/individual/user/userProfile/${id}`);
const getUserProfileDetails = (id) => client.get(`/individual/user/getUserProfileDetails?userId=${id}`)
const postDropDownValue = (data) => client.post(`/individual/user/postDropDownValue`, data);
const postEmailTemplate = (data) => client.post(`/individual/user/postEmailTemplate`, data);
const putdropDownValue = (data) => client.put(`/individual/user/putDropDownValue`, data);
const deleteDropDownValue = (tableType, id) => client.delete(`individual/user/deleteDropDownValue?questionId=${id}&type=${tableType}`);
const postCategoryValue = (data) => client.post(`/individual/user/postCategoryValue`, data);
const putCategoryValue = (data) => client.put(`/individual/user/putCategoryValue`, data);
const postSUbCategoryValue = (data) => client.post(`/individual/user/postSubCategoryValue`, data);
const putSubCategoryValue = (data, id) => client.put(`/individual/user/putSubCategoryValue?id=${id}`, data);
const deleteCategoryValue = (id) => client.delete(`individual/user/deleteCategoryValue?questionId=${id}`);
const deleteSubCategoryValue = (id) => client.delete(`individual/user/deleteSubCategoryValue?questionId=${id}`);

const updateQuestion = (questionId, data) => client.put(`/course/updateQuestionByid?questionId=${questionId}`, data);
const getAllGeneralAssessment1 = () => client.get(`/course/getallgeneralassessment1`);
const getSerchedCourse = (data) => client.get(`/user/enroll/course/searchedCourse?search=${data}`)
const postTagValue = (data) => client.post(`/individual/user/postTagValue`, data);
const deleteTagValue = (id) => client.delete(`individual/user/deleteTagValue?questionId=${id}`);
const putTagValue = (data) => client.put(`/individual/user/putTagValue`, data);
const getCategoryLists = () => client.get('/individual/user/getCategoryValue');
const getTagLists = () => client.get('/individual/user/getTagValue');
const UpdateSATQuestionsBasedOnId = (questionId, data) => client.put(`/course/UpdateSATQuestionsBasedOnId?questionId=${questionId}`, data);
const postAssessmentStatus = (data) => client.post('/individual/user/postassessmentstatus', data);
const postAssessmentSubmit = (data) => client.post('/individual/user/assessmentresult', data);
const getAssessmentDetails = (id, assessmentId) => client.get(`/individual/user/getallassessmentdetailsbyId?assessmentId=${assessmentId}&UserId=${id}`);
const getGenericAssessmentDropDown = ({ page, pageSize, search, audience, assessment_tier, assessment_type } = {}) => {
  const params = new URLSearchParams();
  if (page) params.append('page', page);
  if (pageSize) params.append('pageSize', pageSize);
  if (search) params.append('search', search);
  if (audience) params.append('audience', audience);
  if (assessment_tier) params.append('assessment_tier', assessment_tier);
  if (assessment_type) params.append('assessment_type', assessment_type);
  const query = params.toString() ? `?${params.toString()}` : '';
  return client.get(`/course/getgenericassessmentsdropdown${query}`);
};
const getSummaryById = (id, assessmentId, attemptCount) => client.get(`/individual/user/getSummaryById?assessmentId=${assessmentId}&UserId=${id}&attemptCount=${attemptCount}`);
const getAssessmentDetailsById = (id) => client.get(`/individual/user/getAllAssessmentByUserId?UserId=${id}`);
const deleteAssessmentById = (userid, assessmentId) => client.put(`/individual/user/deleteAllAssessmentByUserId?UserId=${userid}&&assessmentId=${assessmentId}`);
const getAssessmentCountById = (userid, assessmentId) => client.get(`/individual/user/assessmentresultcount?UserId=${userid}&&assessmentId=${assessmentId}`);
const deleteGeneralAssessment = (assessmentId) => client.delete(`/course/deleteCognitiveSkillGAT?Id=${assessmentId}`);
const getCourseBasedOnId = (Id) => client.get(`/lookup/client/getCourseForAssessmentSelection?id=${Id}`);
const getStartAssessmentData = (assessmentId) => client.get(`/individual/user/getStartAssessment?id=${assessmentId}`);
const getAssessmentData = (assessmentId) => client.get(`/course/editDataCognitiveSkillGA?id=${assessmentId}`);
const createSatQuestion = (data) => client.post('/course/createSATQuestions', data);
const getSATDetails = (page, pageCount, search, questionType) => client.get(`/course/getAllSATQuestions?size=${pageCount}&pageCount=${page}&search=${search}&type=${questionType}`);
const deleteSATDetails = (id, type) => client.put(`/course/deleteSATQuestionByID?questionId=${id}&type=${type}`);
const SatCreation = (data) => client.post('/course/SATAssessment', data);
const ClatCreation = (data) => client.post('/course/ClatAssessment', data);
const ClatUpdate = (data) => client.put('/course/updateClatAssessment', data);
const SatQuestionupload = (data, id) => client.post(`/course/createSATQuestionsupload?id=${id}`, data);
const NEETCreation = (data) => client.post('/course/NEETAssessment', data);
const deleteAssessment = (id) => client.put(`/course/deleteAssessment?id=${id}`);
const getNEETAssessmentStartData = (assessmentId) => client.get(`/individual/user/getNEETAssessmentTestQuestions?id=${assessmentId}`);
const getSatQuestion = (type, searchData, page) => client.get(`/course/getQuestionByQuestionType?type=${type}&search=${searchData}&page=${page}`);
const getStartAssessment = (assessmentId, type) => client.get(`/individual/user/getStartAssessmentSimulation?id=${assessmentId}&type=${type}`);
const postSATResult = (data) => client.post('/individual/user/postAdaptiveResults', data);
const postChapterLevelSATResult = (data) => client.post('/individual/user/chapterlevelSATResult', data);
const getSatDetailsById = (assessmentId) => client.get(`/course/editDataCognitiveSkillGA?id=${assessmentId}`);
const updateSatAssessment = (data, id) => client.put(`/course/updateSATAssessment?id=${id}`, data);
const IRTSatAssessment = (id) => client.post(`/course/updateIRT?id=${id}`);
const getAllAssessmentDetailsById = (assessmentId) => client.get(`/course/geteditAssessment?id=${assessmentId}`);
const updateNEETAssessment = (id, data) => client.put(`/course/updateNEETAssessment?id=${id}`, data);
const updateNEETAssessmentData = (id, data) => client.put(`/course/updateNEETAssessmentData?id=${id}`, data);
const postAssessmentResult = (data) => client.post('/individual/user/AssessmentResults', data);
const getAdaptiveAssessmentAnalysis = (assessmentId, userId, attemptCount, type, index) => client.get(`/individual/user/getAnalysis?id=${assessmentId}&userId=${userId}&attemptCount=${attemptCount}&type=${type}&index=${index}`);
const getAnalysisTestScore = (assessmentId, userId, attemptCount, type) => client.get(`/individual/user/getAnalyticsScore?id=${assessmentId}&userId=${userId}&attemptCount=${attemptCount}&type=${type}`);
const getSatAssessmentCountById = (userid, assessmentId) => client.get(`/individual/user/SATAssessmentCount?UserId=${userid}&&assessmentId=${assessmentId}`);
const postImag = (data) => client.post('/course/screen/uploadImage', data);
const getSatAssessmentResume = (userid, percentage, assessmentId, type, QuestionId) => client.get(`/individual/user/SATResultget?UserId=${userid}&&percentage=${percentage}&&assessmentId=${assessmentId}&&type=${type}&&QuestionId=${QuestionId}`);
const updateSatAssessmentModule = (data, id, authUserId) => client.put(`/course/updateSATAssessmentModule?id=${id}&authUserId=${authUserId}`, data);
const deleteSATAssessmentModule = (moduleId, assessmentId, questionIdToRemove) => client.delete(`/course/deleteSATAssessmentModule?id=${assessmentId}&moduleId=${moduleId}`, questionIdToRemove);
const getQuestionDetails = (id) => client.get(`/course/getQuestionsById?id=${id}`);
const ExcelUploads = (data) => client.post(`/course/screen/uploadFile`, data);
const getQuestions = (id) => client.get(`/course/getQuestions?id=${id}`);
const ChatBotUploads = (data) => client.post(`/course/screen/uploadChatBoatFiles`, data);
const updateNEETAssessmentModule = (id, data, authUserId) => client.put(`/course/updateNEETAssessmentModule?id=${id}&authUserId=${authUserId}`, data);
const updateClatAssessmentModule = (id, data, authUserId, assessmentid) => client.put(`/course/updateClatAssessmentModule?id=${id}&authUserId=${authUserId}&assessmentid=${assessmentid}`, data);
const getAnalysisTestScoreResult = (assessmentId, userId, attemptCount, type) => client.get(`/individual/user/SATTestScoreResult?id=${assessmentId}&userId=${userId}&attemptCount=${attemptCount}&type=${type}`);
const getChapterLevelAnalysis = (assessmentId, userId, attemptCount, type) => client.get(`/individual/user/SATChapterAnalytics?id=${assessmentId}&userId=${userId}&attemptCount=${attemptCount}&type=${type}`);
const createAssessmentType = (data) => client.post('/course/postassessmenttype', data);
const updateAssessmentType = (data, id) => client.put(`/course/putassessmenttypebyId?id=${id}`, data);
const deleteAssessmentType = (id) => client.delete(`/course/deleteassessmenttypebyId?id=${id}`);
const getAssessmentTypeDropdown = () => client.get('/course/assessment-type-dropdown');
const getQuestionTypeDropdown = () => client.get('/course/question-type-dropdown');
const createQuestionType = (data) => client.post('/course/postquestiontype', data);
const updateQuestionType = (data, id) => client.put(`/course/putquestiontypebyId?id=${id}`, data);
const deleteQuestionType = (id) => client.delete(`/course/deletequestiontypebyId?id=${id}`);
const getModulesDropdown = (assessmentId) => {
  const params = assessmentId ? `?assessmentid=${assessmentId}` : '';
  return client.get(`/course/modules-dropdown${params}`);
};
const getChapterDropdown = (sourceId) => client.get(`/course/chapter-dropdown?sourceid=${sourceId}`);
const getCourseCategoryDropdown = () => client.get('/course/course-category-dropdown');
const getB2CCategoryList = () => client.get('/course/getb2ccategorylist');
const createB2CCategory = (data) => client.post('/course/postb2ccategory', data);
const updateB2CCategory = (data, id) => client.put(`/course/putb2ccategorybyId?id=${id}`, data);
const updateB2CSortOrder = (data) => client.put('/course/putb2ccategorysortorder', data);
const getMultipleQuestionDetails = (data) => client.get(`/course/multiplequestiondetailsget?data=${data}`);
const getQuestionFullDetails = (data) => client.get(`/course/questiondetailsget?data=${data}`);
const screenlevelTest = (data) => client.post(`/individual/user/screenLevelResult`, data);
const UpdateGeneralAssessmentMaintenance = (id, data, type) => client.put(`/course/updateassessmenttoggle?id=${id}&is_published=${data}&type=${type}`)
const UpdateChatStatus = (id, userId, data, suggestion) => client.put(`/individual/user/updateChatStatus?Id=${id}&&userId=${userId}&&data=${data}&&suggestion=${suggestion}`)
const getAllAssessmentData = (search, page, limit, type) => client.get(`/course/getAllAssessmentData?search=${search}&page=${page}&limit=${limit}&&type=${type}`);
const captureUserActivity = (data) => client.post('/individual/user/logActivity', data);
const getUserActivityLog = (userId) => client.get(`/individual/user/activityLog?userId=${userId}`);
const requestData = () => client.post('/individual/user/dataExportRequest');
const getDataExportRequest = () => client.get('/individual/user/getdataExportRequest');
const UserBillingDetails = (userId) => client.get(`/individual/user/getUserBillingDetails?userId=${userId}`);
const setUserHardDeleteStatus = (userId) => client.put(`/individual/user/hardDeleteStatus?userId=${userId}`);
const NEETAssessmentCreation = (data) => client.post('/course/createNEETAssessment', data);
const getNEETAnalyticsDetails = (userId, assessmentId, attemptedCount) => client.get(`/individual/user/getNEETAnalytics?user_id=${userId}&&assessment_id=${assessmentId}&&attempted_count=${attemptedCount}`);
const createPassage = (data) => client.post('/course/createPassage', data);
const getPassage = (page, size, type, search) => client.get(`/course/getPassage?page=${page}&size=${size}&type=${type}&search=${search}`);
const updatePassage = (data) => client.put('/course/updatePassage', data);
const deletePassage = (id) => client.put(`/course/deletePassageById?id=${id}`);
const getNeetAssessmentCount = (assessmentId, userId) => client.get(`/individual/user/getNEETAssessmentCountBasedonId?assessmentId=${assessmentId}&userId=${userId}`);
const getSatChapterList = (type, userId) => client.get(`/course/chapterList?type=${type}&userId=${userId}`);
const getSatChapterListAdmin = (type) => client.get(`/course/chapterListadmin?type=${type}`);
const getAssessmentType = () => client.get(`/course/getassessmenttypes`);
const getStartSATChapterAssessment = (chapterid, type) => client.get(`/individual/user/getChapterLeveltest?chapter_id=${chapterid}&type=${type}`);
const createChapter = (data, userId) => client.post(`/course/createChapter?userId=${userId}`, data);
const updateChapter = (data, id) => client.put(`/course/updateChapter?id=${id}`, data);
const deleteChapter = (id) => client.delete(`/course/deleteChapter?id=${id}`);
const IndividualChapterDetails = (id, userId) => client.get(`/assessment/getIndividualchapterdetails?id=${id}&&userId=${userId}`);
const CourseCompletion = (data, userId,userRole) => client.post(`/course/courseCompletion?userId=${userId}&userRole=${userRole}`, data);
const getAssessmentSource = (search, type, status, page, limit) => client.get(`/assessment/getAssessmentSource?search=${search}&type=${type}&status=${status}&page=${page}&limit=${limit}`);
const AssessmentSourceCreation = (data) => client.post(`/assessment/postAssessmentSourceCreation`, data);
const getAssessmentSourceBasedonId = (id) => client.get(`/assessment/getAssessmentSourceById?id=${id}`);
const getSourceChaptersPaginated = (id, page, limit, search, difficulty, creator) => client.get(`/assessment/getSourceChaptersPaginated?id=${id}&page=${page}&limit=${limit}&search=${search}&difficulty=${difficulty}&creator=${creator}`);
const UpdateSourceCreation = (data, id) => client.put(`/assessment/putAssessmentSourceUpdate?id=${id}`, data);
const getSourceBasedonCategory = (category) => client.get(`/assessment/getSourceBasedonCategory?category=${category}`);
const AssessmentCreate = (data) => client.post(`/assessment/createassessment`, data);
const UpdateAssessment = (id, data) => client.put(`/assessment/updateassessment?id=${id}`, data);
const getContentCreatorDashboard = (id) => client.get(`/course/content-creator-dashboard?id=${id}`);
const getAssessments = (search, type, status, page, size,category,length) => client.get(`/assessment/getAssessments?search=${search}&&type=${type}&&status=${status}&&page=${page}&&size=${size}&&category=${category}&&length=${length}`);
const getAssessmentById = (id) => client.get(`/assessment/getAssessmentBasedonId?id=${id}`);
const createChapterInSource = (data, userId) => client.post(`/assessment/createChapterInSource?userId=${userId}`, data);
const updateChapterInSource = (data, id) => client.put(`/assessment/updateChapterInSource?id=${id}`, data);
const deleteChapterInSource = (id) => client.delete(`/assessment/deleteChapterInSource?id=${id}`);
const getQuestionsByChapterId = (id, page, pageSize, search, difficulty, creator) => client.get(`/assessment/getQuestionsByChapterId?id=${id}&page=${page}&pageSize=${pageSize}&search=${search}&difficulty=${difficulty}&creator=${creator}`);
const deletQuestionByid = (id) => client.delete(`/assessment/deleteBasedonId?id=${id}`);
const deleteSourceByid = (id) => client.delete(`/assessment/deleteBasedonSourceId?id=${id}`);
const deleteChapterByid = (id) => client.delete(`/assessment/deleteBasedonChapterId?id=${id}`);
const getAssessmentCourseDetail = (page, size, search, type, status, audience, subType) => client.get(`/assessment/getAssessmentCourseDetail?page=${page}&size=${size}&search=${search}&type=${type}&status=${status}&audience=${audience}&subType=${subType}`);
const getIndividualDetailsByAdmin = (id) => client.get(`/individual/user/getindividualdetails?id=${id}`);
const getRecommendedAssessmentByUserId = (id) => client.get(`/individual/user/getRecommendedAssessmentByUserId?id=${id}`);
const getUserOnboardDetailsByAdmin = (userId) => client.get(`/assessment/admin/onboardDetails?userId=${userId}`);
const getDashboardPlatform = (days) => client.get(`/dashboard/platformhealth?days=${days}`);
const getDashboardAssessment = (days) => client.get(`/dashboard/dashboardassessment?days=${days}`);
const getAssessmentLeaderboard = (assessmentId) => client.get(`/dashboard/assessment/${assessmentId}/leaderboard`);
const getAssessmentEngagement = (activityFilter) => client.get(`/dashboard/assessment-engagement?activityFilter=${activityFilter}`);
const sendAssessmentEngagementEmail = (segment, userIds) => client.post(`/dashboard/assessment-engagement/send-email`, { segment, userIds });
const getAllSchemas = (page = 1, pageCount = 10, search = '') => client.get(`/schema?page=${page}&pageCount=${pageCount}&search=${search}`);
const getSchemaById = (id) => client.get(`/schema/${id}`);
const createSchema = (data) => client.post(`/schema`, data);
const updateSchema = (id, data) => client.put(`/schema/${id}`, data);
const deleteSchema = (id) => client.delete(`/schema/${id}`);
const getSchemaStorage = () => client.get(`/schema/storage`);
const saveClientContract = (clientId, data) => client.post(`/client/contract?clientId=${clientId}`, JSON.stringify(data));
const getClientAuditLog = (clientId, params = {}) => { const qs = new URLSearchParams({ clientId, ...params }).toString(); return client.get(`/client/audit-log?${qs}`); };
const getClientContract = (clientId) => client.get(`/client/contract?clientId=${clientId}`);
const getClientsDashboard = (page = 0, size = 10, search = '', status = 'all') => client.get(`/client/dashboard?page=${page}&size=${size}&search=${search}&status=${status}`);
const AssessmentScore = (data, assessmentId) => client.post(`/assessment/assessmentscore?assessmentId=${assessmentId}`, data);
const postReplaceAdmin = (clientId, data) => client.put(`/client/replace?clientId=${clientId}`, data);
const createTenantUser = (data) => client.post(`/client-admin/users`, data);
const getBillingContract = (clientId) => client.get(`/client-admin/contract/billing?clientId=${clientId}`);
const getBillingPaymentHistory = (clientId) => client.get(`/client-admin/billing-history?clientId=${clientId}`);
const generateCourseKnowledge = (courseId) => client.post(`/ai/generate?courseId=${courseId}`);
const getInitialQuestions = (courseId) => client.get(`/ai/questions/?courseId=${courseId}`);
const searchQuestions = (courseId, searchText) => client.post(`/ai/search`, { courseId, searchText });
const askQuestion = (courseId, questionId, questionText, forceAI = false, sessionId = null) => client.post(`/ai/ask`, { courseId, questionId, questionText, forceAI, sessionId });
const getassessmentscore = () => client.get(`/assessment/getassessmentscore`);
const DeleteAssessmentscore = (id) => client.delete(`/assessment/deleteAssessmentScoreTemplate?id=${id}`);
const getAssessmentCategory = () => client.get(`/assessment/assessment-category-dropdown`);
const getAssessmentSubject = (type) => client.get(`/assessment/assessment-subject?type=${type}`);
const getAssessmentSubType = (type) => client.get(`/assessment/assessment-subtype?type=${type}`);
const createAiSession = (courseId) => client.post(`/ai/session`, { courseId });
const getAiSessionLogs = (userId) => client.get(`/ai/session/user/${userId}`);
const getClientReports = (params = {}) => {
  const query = new URLSearchParams({
    page: params.page ?? 0,
    size: params.size ?? 20,
    search: params.search ?? '',
    status: params.status ?? 'ALL',
    type: params.type ?? 'ALL',
  }).toString();
  return client.get(`/client-admin/reports?${query}`);
}
const getBatchType = () => client.get('/assessment/assessment-batch');
const useronBoard = (data) => client.post('/assessment/useronboard', data);
const getUserOnBoardByUserId = () => client.get('/assessment/getUserOnBoardByUserId');
const getEbooks = (searchOrParams = '', page = 1, size = 10) => {
  const params =
    searchOrParams && typeof searchOrParams === 'object'
      ? { ...searchOrParams }
      : { search: searchOrParams, page, size };
 
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === '' || value === null || value === undefined) return;
    qs.append(key, value);
  });
 
  return client.get(`/e-books/ebooks?${qs.toString()}`);
};
const getEbookById = (id) => client.get(`/e-books/ebooks/${id}`);
const createEbook = (data) => client.post('/e-books/ebooks', data);
const updateEbook = (id, data) => client.put(`/e-books/ebooks/${id}`, data);
const deleteEbook = (id) => client.delete(`/e-books/ebooks/${id}`);
const publishEbook = (id, isPublished) => client.patch(`/e-books/ebooks/${id}/publish`, { isPublished });
// Chapters
// Queues a .docx for background parsing. Resolves as soon as the job is on the
// queue (HTTP 202) - the import itself finishes minutes later and the uploader is
// emailed, so callers must poll `getEbookImportJob` rather than await the result.
const importEbookDocument = (ebookId, formData, onUploadProgress) =>
  client.post(`/e-books/ebooks/${ebookId}/import`, formData, { onUploadProgress });
// Large documents can't be POSTed through the API (10 MB gateway cap), so the
// browser asks for a presigned URL, PUTs the .docx straight to S3, then calls
// import with just the returned object key. This goes direct to S3 rather than
// through the API client, because the target is not our API.
const getEbookImportUploadUrl = (ebookId, fileName) =>
  client.get(`/e-books/ebooks/${ebookId}/import-upload-url?fileName=${encodeURIComponent(fileName)}`);
// XHR rather than fetch: the Fetch API cannot report upload progress at all, so
// the dialog had nothing to show and sat on a hardcoded 10% for the whole
// transfer. Resolves with the same { ok } shape the callers already check.
const putFileToUrl = (url, file, onUploadProgress) => new Promise((resolve) => {
  const xhr = new XMLHttpRequest();
  xhr.open('PUT', url);
  if (onUploadProgress) {
    xhr.upload.onprogress = (e) => { if (e.lengthComputable) onUploadProgress(e); };
  }
  xhr.onload  = () => resolve({ ok: xhr.status >= 200 && xhr.status < 300, status: xhr.status });
  xhr.onerror = () => resolve({ ok: false, status: 0 });
  xhr.onabort = () => resolve({ ok: false, status: 0 });
  xhr.send(file);
});
const importEbookDocumentByKey = (ebookId, body) =>
  client.post(`/e-books/ebooks/${ebookId}/import`, body);
const getEbookImportJob = (jobId) => client.get(`/e-books/import-jobs/${jobId}`);
// Images and video dropped into the eBook editor. Unlike the generic course
// image upload, this accepts video too, which the editor needs for drag-and-drop.
const uploadEbookMedia = (formData) => client.post('/e-books/media', formData);
const getLatestEbookImportJob = (ebookId) => client.get(`/e-books/ebooks/${ebookId}/import-job`);

// The assessment chapters an eBook chapter can be tagged to — public.assessment_modules,
// the same ids questions.chapter_id[] points at. `search` is matched against both the
// chapter name and its assessment source's title.
const getAssessmentChaptersForEbook = (search = '', limit = 200) =>
  client.get(`/e-books/assessment-chapters?search=${encodeURIComponent(search)}&limit=${limit}`);
// Reverse lookup: every eBook chapter that teaches a given assessment chapter.
const getEbookChaptersForAssessmentChapter = (assessmentChapterId) =>
  client.get(`/e-books/assessment-chapters/${assessmentChapterId}/ebook-chapters`);

const getEbookChapters = (ebookId) => client.get(`/e-books/ebooks/${ebookId}/chapters`);
const createEbookChapter = (ebookId, data) => client.post(`/e-books/ebooks/${ebookId}/chapters`, data);
const updateEbookChapter = (id, data) => client.put(`/e-books/chapters/${id}`, data);
const deleteEbookChapter = (id) => client.delete(`/e-books/chapters/${id}`);
const publishEbookChapter = (id, isPublished) => client.patch(`/e-books/chapters/${id}/publish`, { isPublished });
const reorderEbookChapters = (ebookId, items) => client.patch(`/e-books/ebooks/${ebookId}/chapters/reorder`, { items });

// Chapter-level document import. Same idea as the whole-eBook importer, but the
// .docx becomes a single new chapter (with its topics) appended to an existing
// eBook, so an author can build a book chapter-by-chapter from separate files.
// Response returns the created chapter, shaped like getEbookChapters rows.
const importEbookChapterDocument = (ebookId, formData, onUploadProgress) =>
  client.post(`/e-books/ebooks/${ebookId}/chapters/import`, formData, { onUploadProgress });
// Large files: presigned S3 URL first, then import with just the object key
// (mirrors getEbookImportUploadUrl / importEbookDocumentByKey).
const getEbookChapterImportUploadUrl = (ebookId, fileName) =>
  client.get(`/e-books/ebooks/${ebookId}/chapters/import-upload-url?fileName=${encodeURIComponent(fileName)}`);
const importEbookChapterDocumentByKey = (ebookId, body) =>
  client.post(`/e-books/ebooks/${ebookId}/chapters/import`, body);

// Topics
const getChapterTopics = (chapterId) => client.get(`/e-books/chapters/${chapterId}/topics`);
const getTopicById = (id) => client.get(`/e-books/topics/${id}`);
const createChapterTopic = (chapterId, data) => client.post(`/e-books/chapters/${chapterId}/topics`, data);
const updateEbookTopic = (id, data) => client.put(`/e-books/topics/${id}`, data);
const deleteEbookTopic = (id) => client.delete(`/e-books/topics/${id}`);
const publishEbookTopic = (id, isPublished) => client.patch(`/e-books/topics/${id}/publish`, { isPublished });
const reorderChapterTopics = (chapterId, items) => client.patch(`/e-books/chapters/${chapterId}/topics/reorder`, { items });
// Media
const getTopicMedia = (topicId) => client.get(`/e-books/topics/${topicId}/media`);
const createTopicMedia = (topicId, data) => client.post(`/e-books/topics/${topicId}/media`, data);
const updateTopicMedia = (id, data) => client.put(`/e-books/media/${id}`, data);
const deleteTopicMedia = (id) => client.delete(`/e-books/media/${id}`);

// ── Student eBook APIs ────────────────────────────────────────────────────────
// `opts.assessmentTypeId` filters the catalogue by eBook series: a positive
// assessment_type_lk id, or the string 'other' for eBooks with no series.
const getPublishedEbooks = (opts = {}) => {
  const qs = new URLSearchParams();
  if (opts.assessmentTypeId !== undefined && opts.assessmentTypeId !== null && opts.assessmentTypeId !== '') {
    qs.append('assessmentTypeId', opts.assessmentTypeId);
  }
  const suffix = qs.toString();
  return client.get(`/e-books/student/ebooks${suffix ? `?${suffix}` : ''}`);
};
const getEbookTOC = (ebookId) => client.get(`/e-books/student/ebooks/${ebookId}/toc`);
const getStudentTopic = (topicId) => client.get(`/e-books/student/topics/${topicId}`);
const getStudentEbookAnalytics = (ebookId) => client.get(`/e-books/student/ebooks/${ebookId}/analytics`);
const upsertReadingProgress = (data) => client.post('/e-books/student/progress', data);
const getTopicHighlights = (topicId) => client.get(`/e-books/student/topics/${topicId}/highlights`);
const createStudentHighlight = (data) => client.post('/e-books/student/highlights', data);
const deleteStudentHighlight = (id) => client.delete(`/e-books/student/highlights/${id}`);
const getTopicNotes = (topicId) => client.get(`/e-books/student/topics/${topicId}/notes`);
const createStudentNote = (data) => client.post('/e-books/student/notes', data);
const updateStudentNote = (id, data) => client.put(`/e-books/student/notes/${id}`, data);
const deleteStudentNote = (id) => client.delete(`/e-books/student/notes/${id}`);
const getStudentBookmarks = () => client.get('/e-books/student/bookmarks');
const createStudentBookmark = (data) => client.post('/e-books/student/bookmarks', data);
const deleteStudentBookmark = (id) => client.delete(`/e-books/student/bookmarks/${id}`);

// ── Student eBook AI ──────────────────────────────────────────────────────────
// One chat session per topic. `sendAiChatMessage` renames the drawer's `content`
// field to the `message` the /ai/ask endpoint expects; the backend persists both
// sides of the turn and grounds the answer in the topic's own markdown.
const getOrCreateAiChatSession = (data) => client.post('/e-books/student/ai/session', data);
const getAiChatMessages = (sessionId) => client.get(`/e-books/student/ai/sessions/${sessionId}/messages`);
const sendAiChatMessage = ({ sessionId, topicId, content, selectedText, history }) =>
  client.post('/e-books/student/ai/ask', { sessionId, topicId, message: content, selectedText, history });
// type: 'summary' | 'flashcards' | 'quiz' | 'explain'
const getEbookAiContent = (topicId) => client.get(`/e-books/student/ai/topics/${topicId}/content`);
const generateEbookAiContent = (data) => client.post('/e-books/student/ai/generate', data);
const postExamViolation = (data) => client.post('/assessment/exam-violation', data);
const getExamViolations = (assessmentId) => client.get(`/assessment/exam-violations/${assessmentId}`);
// Attempt flashcards — built from the questions missed on one attempt. generate is a
// resumable job: call it until status is COMPLETED / SKIPPED / FAILED.
const generateAttemptFlashcards = ({ assessmentId, attemptCount }) => client.post('/assessment/flashcards/generate', { assessmentId, attemptCount });
const getAttemptFlashcards = ({ assessmentId, attemptCount }) => client.get(`/assessment/flashcards?assessmentId=${assessmentId}&attemptCount=${attemptCount}`);
const reviewAttemptFlashcard = (id, status) => client.patch(`/assessment/flashcards/${id}/review`, { status });
// Topic flashcards — the standalone deck, for learners with no attempt yet.
const generateTopicFlashcards = ({ courseId, topics, count }) => client.post('/ai/flashcards/generate', { courseId, topics, count });
const getAnnouncements = (limit) => client.get(`/client-admin/announcements${limit ? `?limit=${limit}` : ''}`);
const getAnnouncementById = (id) => client.get(`/client-admin/announcements/${id}`);
const createAnnouncement = (data) => client.post('/client-admin/announcements', data);
const markAnnouncementRead = (id) => client.post(`/client-admin/announcements/${id}/read`);
const acknowledgeAnnouncement = (id) => client.post(`/client-admin/announcements/${id}/acknowledge`);
const getAnnouncementReplies = (id) => client.get(`/client-admin/announcements/${id}/replies`);
const getAnnouncementUserStatus = (id) => client.get(`/client-admin/announcements/${id}/users`);
const createAnnouncementReply = (id, data) => client.post(`/client-admin/announcements/${id}/replies`, data);
const getAnnouncementThreads = (id) => client.get(`/client-admin/announcements/${id}/threads`);
const getAnnouncementThread = (id, userId) => client.get(`/client-admin/announcements/${id}/threads/${userId}`);
const getDbSchema = (schema = 'public') => client.get(`/dashboard/db-schema?schema=${schema}`);
const getEbookStandalonePlans = () => client.get('/e-books/student/ebooks/plans/standalone');
const getEbookBundlePlans = () => client.get('/e-books/student/ebooks/plans/bundle');
const getUserEbookProgress = () => client.get('/e-books/student/ebooks/progress');

const getEbookFullDetails = (id) => client.get(`/e-books/student/ebooks/details/${id}`);
// eBooks whose tagged chapters overlap a finished assessment — for the
// post-completion recommendation popup.
const getRecommendedEbooksForAssessment = (assessmentId) =>
  client.get(`/e-books/student/assessments/${assessmentId}/recommended-ebooks`);
const getEbookFullAnalytics = (id) => client.get(`/e-books/student/ebooks/analytics/${id}`);
const getExportDataFromPublic = () => client.get(`/assessment/exportdatafrompublic`);
const ImportDataFromPublic = (data) => client.post(`/assessment/importdatafrompublic`,data);

const getAssessmentEngagementByRange = (fromDate, toDate) => client.get(`/dashboard/assessment-engagement?fromDate=${fromDate}&toDate=${toDate}`);
const getLifecycleFunnel = (fromDate, toDate) => client.get(`/dashboard/lifecycle-funnel?fromDate=${fromDate}&toDate=${toDate}`);
const getStuckUsers = (category, fromDate, toDate) => client.get(`/dashboard/stuck-users?category=${category}&fromDate=${fromDate}&toDate=${toDate}`);
const getDashboardEngagement = (period) => client.get(`/dashboard/engagement?filterDays=${period}`);
const getEngagementUsersByDate = (date, bucket, period) => client.get(`/dashboard/engagement/users?date=${date}&bucket=${bucket}&filterDays=${period}`);
const getAdminUsers = (page = 1, limit = 10, search = '', role = '') =>
  client.get(`/admin-user?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}&role=${role}`);
const getAssignableRoles = () => client.get(`/admin-user/roles`);
const postAdminUser = (data) => client.post(`/admin-user`, data);
const putAdminUser = (data, id) => client.put(`/admin-user?id=${id}`, data);
const setAdminUserStatus = (id, status) => client.patch(`/admin-user/status?id=${id}&status=${status}`);
const getRoles = (page = 1, pageCount = 25, search = '', includeInactive = false) =>
  client.get(`/role?page=${page}&pageCount=${pageCount}&search=${encodeURIComponent(search)}&includeInactive=${includeInactive}`);
const getRoleById = (id) => client.get(`/role/${id}`);
const getRoleEndpoints = () => client.get(`/role/available-endpoints`);
const createRole = (data) => client.post(`/role`, data);
const updateRole = (id, data) => client.put(`/role/${id}`, data);
const deleteRole = (id) => client.delete(`/role/${id}`);
const getUserTimeline = (userId) => client.get(`/dashboard/user-timeline/${userId}`);
const getMailTemplates = (page = 1, pageCount = 25, search = '', sort = '', sortOrder = '') =>
client.get(`/mail-template?page=${page}&pageCount=${pageCount}&search=${encodeURIComponent(search)}&sort=${sort}&sortOrder=${sortOrder}`);
const getMailTemplateById = (id) => client.get(`/mail-template/${id}`);
const createMailTemplate = (data) => client.post(`/mail-template`, data);
const updateMailTemplate = (id, data) => client.put(`/mail-template/${id}`, data);
const deleteMailTemplate = (id) => client.delete(`/mail-template/${id}`);

const getUsersByStatus = (status,fromDate,toDate, page , pageSize,search) => client.get(`/dashboard/getUsersByStatus?status=${status}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&pageSize=${pageSize}&search=${search}`);
const getSubscribedUserList = (page,logsLimit,search, fromDate, toDate,status) => client.get(`/dashboard/subscribed-users?page=${page}&logsLimit=${logsLimit}&search=${search}&fromDate=${fromDate}&toDate=${toDate}&status=${status}`);
const getCrisisTemplate = () => client.get(`/dashboard/getcrisistemplate`);
const sendCrisisEmail = (template,data) => client.post(`/dashboard/sendcrisisemail?template=${template}`, data);
const LoginPageImage = (data) => client.put(`/authenticate/websiteImageUpload`, data);
const updateAssessmentOrder = (data) => client.put(`/assessment/assessmentsorder`, data);
const getEngagementSummary = (days, active_min,status ) => client.get(`/dashboard/getEngagementSummary?days=${days}&active_min=${active_min}&status=${status}`);
const getEngagementUsers = (metric, days, active_min, page, page_size, search,status) => client.get(`/dashboard/getEngagementUsers?metric=${metric}&days=${days}&active_min=${active_min}&page=${page}&page_size=${page_size}&search=${search}&status=${status}`);


export default {
  getDashboardEngagement,
  getEngagementUsersByDate,
  getAssessmentEngagementByRange,
  getLifecycleFunnel,
  getStuckUsers,
  getExportDataFromPublic,
  ImportDataFromPublic,
  getEbookFullAnalytics,
  getEbookFullDetails,
  getRecommendedEbooksForAssessment,
  getEbookStandalonePlans,
  getEbookBundlePlans,
  getUserEbookProgress,
  getInitialQuestions,
  createAiSession,
  getAiSessionLogs,
  getClientReports,

  searchQuestions,
  askQuestion,
  generateCourseKnowledge,
  getBillingContract,
  getBillingPaymentHistory,
  getContentCreatorDashboard,
  getQuestions,
  updateisCompleteResult,
  createIntroTemplate,
  getIntroTemplate,
  putIntroTemplate,
  deleteTemplate,
  Updateusercreation,
  UpdateusercreationClientAdmin,
  createQuestionsOld,
  createQuestions,
  getModuleDataValidation,
  getLookUpData,
  getSubcategoryLookUp,
  getClientList,
  getIndividualList,
  getIndividualListByPlan,
  getIndividualListDownload,
  createCourse,
  getCourseLists,
  getCustomerPortal,
  updateNotificationPreferences,
  getNotificationPreferences,
  deleteCourseVideo,
  getChatResult,
  getCourseContent,
  getCourseModule,
  getCourseDetailsById,
  suspendUser,
  getReferenceFileDetails,
  getCourseModuleTopics,
  deleteCourseModule,
  editCourseDetails,
  createCourseModule,
  editCourseModuleName,
  editCourseSubModuleName,
  createCourseSubModule,
  createCourseTopic,
  deleteSubModules,
  editSubModuleTopicName,
  createActionScreenDetails,
  createVideoScreenDetails,
  createSuccessScreenDetails,
  getVideoScreenDetailsById,
  getActionScreenDetailsById,
  getCourseCategoryDropdown,
  getB2CCategoryList,
  createB2CCategory,
  updateB2CCategory,
  updateB2CSortOrder,
  getIntroScreenDetailsById,
  getSuccessScreenDetailsById,
  deleteScreenById,
  deleteSubModuleTopic,
  getLookUpStateData,
  createIntroScreenDetails,
  postClientDetails,
  editClientDetailsByID,
  getClientDetalsById,
  getLookUpDetails,
  deleteClientDetailsByID,
  getTenantStorage,
  postCreateAdmin,
  getClientInfo,
  getusers,
  deleteUserDetails,
  updateIntroScreenDetails,
  getDashboardRevenue,
  updateVideoScreenDetails,
  updateSuccessScreenDetails,
  handleClientStatus,
  handleUserStatus,
  profileUpdate,
  getSubscriptionData,
  postSubsrciptionplan,
  deleteSubsrciptionplanByID,
  editSubsrciptionplan,
  getB2BTemplatePlans,
  assignB2BTemplateToClient,
  getSubscriptionCoursePlansByID,
  updateActionScreenDetails,
  handleSubscriptionStatus,
  getCourseDetailsByIdOne,
  editCourseDetailsByIdOne,
  deleteActionScreenKeys,
  createActionScreenKeys,
  deleteCourseById,
  getDashBoardValues,
  getDashBoardChart,
  updateModulePositions,
  updateTopicPositions,
  updateCourseStatus,
  getCourseStatus,
  updateSubModulePositions,
  updateSubModuleParent,
  updateScreenPositions,
  createActionScreenKeysForCaseStudy,
  courseTrial,
  postCloningCourses,
  getAdminUserList,
  enrollUserToCourse,
  enrollNewUser,
  handleDeleteModuleVideo,
  handleDeleteSubmoduleVideo,
  getEnrolledUser,
  deleteEnrolledUser,
  handleDeleteScreenAudio,
  getAuthors,
  getLanguageCode,
  importModules,
  createReference,
  editCourseSubModuleRef,
  deletreferenceDetails,
  getQuestionData,
  getQuestionDataMCQ,
  getQuestionDataMCQNew,
  createCourseAssessMent,
  getDetailsById,
  UpdateCourseAssessMentBasedonId,
  genericAssessMent,
  getAllQuestion,
  updateQuestion,
  deleteQuestion,
  getGenericAssessment,
  updategenericAssessMent,
  deleteGenericAssessment,
  postContentWriterList,
  putContentWriterList,
  deleteContentWriterList,
  getContentWriterList,
  getBasicDetails,
  getUserProfileDetails,
  postEmailTemplate,
  postDropDownValue,
  deleteDropDownValue,
  putdropDownValue,
  postCategoryValue,
  putCategoryValue,
  deleteCategoryValue,
  deleteSubCategoryValue,
  postTagValue,
  getAllGeneralAssessment1,
  getSerchedCourse,
  getBannerDetails,
  getLearnerViewing,
  getAllCourseList,
  getCategoryLists,
  getTagLists,
  deleteTagValue,
  putTagValue,
  UpdateGeneralAssessmentStatus,
  postAssessmentStatus,
  postAssessmentSubmit,
  getAssessmentDetails,
  getGenericAssessmentDropDown,
  getSummaryById,
  getAssessmentDetailsById,
  deleteAssessmentById,
  getAssessmentCountById,
  CognitiveSkillGA,
  getCognitiveSkillGA,
  CognitiveSkillGAUpdate,
  deleteGeneralAssessment,
  getCourseBasedOnId,
  getStartAssessmentData,
  getAssessmentData,
  createSatQuestion,
  getSATDetails,
  deleteSATDetails,
  SatCreation,
  ClatCreation,
  ClatUpdate,
  SatQuestionupload,
  getSatQuestion,
  getStartAssessment,
  getSATAssessmentAdmin,
  postSATResult,
  postChapterLevelSATResult,
  getSatDetailsById,
  updateSatAssessment,
  IRTSatAssessment,
  getAdaptiveAssessmentAnalysis,
  getAnalysisTestScore,
  getSatAssessmentCountById,
  postImag,
  getSatAssessmentResume,
  UpdateSATQuestionsBasedOnId,
  updateSatAssessmentModule,
  deleteSATAssessmentModule,
  getQuestionDetails,
  ExcelUploads,
  getMultipleQuestionDetails,
  getSATDashBoard,
  getQuestionFullDetails,
  screenlevelTest,
  getUserSubscriptionData,
  postSUbCategoryValue,
  putSubCategoryValue,
  getLLMInteractionLog,
  getLLMInteractionLogByUserId,
  editLLMInteractionLogReviewStatus,
  deleteLLMInteractionLog,
  ChatBotUploads,
  UpdateGeneralAssessmentMaintenance,
  NEETCreation,
  getNEETAssessmentAdmin,
  getAllAssessmentDetailsById,
  updateNEETAssessmentModule,
  updateClatAssessmentModule,
  updateNEETAssessment,
  getUserAssessmentSubscriptionData,
  getUserNeetSubscriptionData,
  getNEETSubjectList,
  getNEETChaptersList,
  UpdateChatStatus,
  NEETAssessmentCreation,
  getNEETAnalyticsDetails,
  createPassage,
  getPassage,
  updatePassage,
  deletePassage,
  getAllAssessmentData,
  captureUserActivity,
  getUserActivityLog,
  requestData,
  getDataExportRequest,
  UserBillingDetails,
  setUserHardDeleteStatus,
  updateNEETAssessmentData,
  getAllNEETQuestion,
  deleteAssessment,
  getLoginPageImage,
  getNEETAssessmentStartData,
  postAssessmentResult,
  getNeetAssessmentCount,
  getSatChapterList,
  getSatChapterListAdmin,
  getAssessmentType,
  getStartSATChapterAssessment,
  createChapter,
  updateChapter,
  deleteChapter,
  IndividualChapterDetails,
  getAnalysisTestScoreResult,
  getChapterLevelAnalysis,
  CourseCompletion,
  AssessmentSourceCreation,
  getAssessmentSource,
  getAssessmentSourceBasedonId,
  getSourceChaptersPaginated,
  UpdateSourceCreation,
  getAssessmentTypeDropdown,
  createAssessmentType,
  updateAssessmentType,
  deleteAssessmentType,
  getQuestionTypeDropdown,
  createQuestionType,
  updateQuestionType,
  deleteQuestionType,
  getModulesDropdown,
  getChapterDropdown,
  getSourceBasedonCategory,
  AssessmentCreate,
  UpdateAssessment,
  getAssessments,
  getAssessmentById,
  createChapterInSource,
  updateChapterInSource,
  deleteChapterInSource,
  getQuestionsByChapterId,
  deletQuestionByid,
  deleteSourceByid,
  deleteChapterByid,
  getAssessmentCourseDetail,
  getIndividualDetailsByAdmin,
  getRecommendedAssessmentByUserId,
  getUserOnboardDetailsByAdmin,
  getDashboardPlatform,
  getDashboardAssessment,
  getAssessmentLeaderboard,
  getAssessmentEngagement,
  sendAssessmentEngagementEmail,
  getAllSchemas,
  getSchemaById,
  createSchema,
  updateSchema,
  deleteSchema,
  getSchemaStorage,
  getClientAuditLog,
  getClientContract,
  saveClientContract,
  getSuperAdminChapters,
  getClientsDashboard,
  AssessmentScore,
  postReplaceAdmin,
  createTenantUser,
  getlearners,
  updateUser,
  postCreateAdminUser,
  getTenentUsers,
  getassessmentscore,
  DeleteAssessmentscore,
  getAssessmentCategory,
  getAssessmentSubject,
  getAssessmentSubType,
  getBatchType,
  useronBoard,
  getUserOnBoardByUserId,
  // EBooks
  getEbooks,
  getEbookById,
  createEbook,
  updateEbook,
  deleteEbook,
  publishEbook,
  importEbookDocument,
  getEbookImportUploadUrl,
  putFileToUrl,
  importEbookDocumentByKey,
  getEbookImportJob,
  getLatestEbookImportJob,
  uploadEbookMedia,
  getAssessmentChaptersForEbook,
  getEbookChaptersForAssessmentChapter,
  getEbookChapters,
  createEbookChapter,
  updateEbookChapter,
  deleteEbookChapter,
  publishEbookChapter,
  reorderEbookChapters,
  getChapterTopics,
  getTopicById,
  createChapterTopic,
  updateEbookTopic,
  deleteEbookTopic,
  publishEbookTopic,
  reorderChapterTopics,
  importEbookChapterDocument,
  getEbookChapterImportUploadUrl,
  importEbookChapterDocumentByKey,
  getTopicMedia,
  createTopicMedia,
  updateTopicMedia,
  deleteTopicMedia,
  // Student eBook APIs
  getPublishedEbooks,
  getEbookTOC,
  getStudentTopic,
  getStudentEbookAnalytics,
  upsertReadingProgress,
  getTopicHighlights,
  createStudentHighlight,
  deleteStudentHighlight,
  getTopicNotes,
  createStudentNote,
  updateStudentNote,
  deleteStudentNote,
  getStudentBookmarks,
  createStudentBookmark,
  deleteStudentBookmark,
  // Student eBook AI
  getOrCreateAiChatSession,
  getAiChatMessages,
  sendAiChatMessage,
  getEbookAiContent,
  generateEbookAiContent,
  postExamViolation,
  getExamViolations,
  generateAttemptFlashcards,
  getAttemptFlashcards,
  reviewAttemptFlashcard,
  generateTopicFlashcards,
  getAnnouncements,
  getAnnouncementById,
  createAnnouncement,
  markAnnouncementRead,
  acknowledgeAnnouncement,
  getAnnouncementReplies,
  getAnnouncementUserStatus,
  createAnnouncementReply,
  getAnnouncementThreads,
  getAnnouncementThread,
  getDbSchema,
  getUserTimeline,
  getAdminUsers,
  getAssignableRoles,
  postAdminUser,
  putAdminUser,
  setAdminUserStatus,
  getRoles,
  getRoleById,
  getRoleEndpoints,
  createRole,
  updateRole,
  deleteRole,
  getMailTemplates,
  getMailTemplateById,
  createMailTemplate,
  updateMailTemplate,
  deleteMailTemplate,
  getUsersByStatus,
  getSubscribedUserList,
  getCrisisTemplate,
  sendCrisisEmail,
  LoginPageImage,
  updateAssessmentOrder,
  getEngagementSummary,
  getEngagementUsers
};